module.exports = __webpack_public_path__ + "static/img/105.2b7b389.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/200818/105.jpg
// module id = /w2t
// module chunks = 0